import { css } from 'lit';

export const EtitleModalStyles = css`
  #etitle-open {
    width: 100%;
  }

  fs-modal-dialog-footer > fs-button {
    margin: 0 var(--fs-size-spacing-medium, 24px),
      0 var(--fs-size-spacing-medium, 24px);
    float: right;
  }
`;
